// لینک‌های اشتراک (/s/<code>) و بازدیدها — هر درخواست شناسه‌ی گوشی را دارد (ورود به حساب لازم نیست)
import { getDeviceId, getLiveProfile } from './device.jsx';

async function call(path, method = 'GET', body) {
  let resp;
  try {
    resp = await fetch(`/api/shares${path}`, {
      method,
      credentials: 'same-origin',
      headers: { 'X-KH-Device': getDeviceId(), ...(body ? { 'Content-Type': 'application/json' } : {}) },
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch (e) {
    const err = new Error('اتصال به سرور برقرار نشد؛ اینترنت را بررسی کنید.');
    err.code = 'network';
    throw err;
  }
  let data = {};
  try {
    data = await resp.json();
  } catch (e) {
    /* */
  }
  if (!resp.ok) {
    const err = new Error((data && data.message) || 'خطایی پیش آمد؛ دوباره امتحان کنید.');
    err.code = (data && data.error) || `http-${resp.status}`;
    throw err;
  }
  return data;
}

const myName = () => (getLiveProfile() || {}).name || undefined;

export const createShare = (designId) => call('', 'POST', { designId, name: myName() });
export const getShare = (code) => call(`/${encodeURIComponent(code)}`);
export const visitShare = (code, entered = false) =>
  call(`/${encodeURIComponent(code)}/visit`, 'POST', { name: myName(), entered }).catch(() => null);
export const listSentShares = () => call('/sent');
// فرستنده واقعاً لینک را فرستاد/کپی کرد → در «فرستاده‌ها» می‌آید (حتی قبل از این‌که گیرنده بازش کند)
export const markShareSent = (code) => call(`/${encodeURIComponent(code)}/sent`, 'POST', {}).catch(() => null);
export const listReceivedShares = () => call('/received');

// چند نفر الان داخلِ هر اتاق‌اند (سرورِ بازدید) → { code: n }
export async function liveCounts(codes) {
  if (!codes.length) return {};
  try {
    const r = await fetch(`/live/rooms?codes=${codes.map(encodeURIComponent).join(',')}`, { cache: 'no-store' });
    return r.ok ? await r.json() : {};
  } catch (e) {
    return {};
  }
}
